<template>
  <div class="assistant-step5">
    <div class="info-banner">
      <div class="info-banner__content">
        <div class="info-banner__text">
          <div class="info-banner__title">
            <h4>{{ $tv('Frontend.Title.Compound', 'ORingConfiguratorImport') }}</h4>
            <ActionInfoFilledIcon
              class="info-banner__icon"
              role="button"
              tabindex="0"
              aria-label="Info"
              @click="showPopup = true"
            />
          </div>
          <p v-text="$tv('Frontend.Message.Material','ORingConfiguratorImport')" />
        </div>
      </div>
      <PopupBase
        :show="showPopup"
        @close-pop-up="showPopup = false"
        :size="popupSizeSmall"
      >
        <div class="info-popup-content">
          <h4>{{ $tv('Frontend.Title.Compound', 'ORingConfiguratorImport') }}</h4>
          <Markdown :text="$tv('Frontend.Info.CompoundOne','ORingConfiguratorImport')" />
        </div>
      </PopupBase>
    </div>
    <div class="oring-assistant__container__cards">
      <div class="card">
        <MaterialSelection
          v-model="oringMaterialIds"
          @bookmark-materials="importMaterials"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import MaterialSelection from './OringMaterialSelection.vue'
import {useORingCalculatorStore} from '~/store/oring-calculator'
import ActionInfoFilledIcon from '~/assets/icons/action_info_filled.svg?component'
import PopupBase from '~/components/popup/PopupBase.vue'
import {POPUP} from '~/assets/js/constants'
import Markdown from '~/components/Markdown.vue'

// Selected materials
const {oringMaterialIds, oringBookmarkedMaterialIds} = storeToRefs(useORingCalculatorStore())

// Popup logic
const showPopup = ref(false)
const popupSizeSmall = POPUP.Size.small

function validate() {
  // Add validation logic here if needed
  // For example, check if required fields are filled
  return true
}

// Function to import materials
function importMaterials() {
  oringMaterialIds.value = oringBookmarkedMaterialIds.value
}

defineExpose({validate})
</script>

<style lang="scss">
.assistant-step5 {
  .material-selection-section {
    margin: 0;
  }

  .info-banner {
    background-color: $color__content--background__secondary;
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 0.25rem;

    &__content {
      display: flex;
      align-items: flex-start;
    }

    &__text {
      flex: 1;

      h4 {
        margin: 0;
        color: $color__primary;
      }

      p {
        margin: 1rem 0 0;
        color: $color__text__default;
      }
    }

    &__title {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    &__icon {
      color: $color__primary;
      height: 1.5rem;
      width: 1.5rem;
      cursor: pointer;
      flex-shrink: 0;
    }
  }

  .info-popup-content {
    h4 {
      margin: 0;
      color: $color__primary;
    }

    p {
      margin: 1rem 0 0;
      line-height: 1.5;
    }
  }

  .oring-assistant__container__cards {
    .card {
      margin: 0 0 1rem;
    }
  }
}
</style>
